/**
 * default config
 * @author jzhu
 */
import organization from './config-organization'
import organizationBrandNode from './config-organizationBrandNode'
import organizationByNoFilter from './config-organizationByNoFilter'
import position from './config-position'
import positionByNoFilter from './config-positionByNoFilter'
import positionCategory from './config-positionCategory'
import user from './config-user'
import user2 from './config-user2'
import offlineProgram from "./config-offlineProgram";
import question from "./config-question";
import questionType from "./config-questionType";
import dealer from './config-dealer'
import exam from './config-exam';
import program from './config-program';
import userIdentity from "./config-userIdentity";
import surveyTemp from "./config-surveyTemp";
import classStudentSign from "./config-classStudentSign";
import survey from "./config-survey";
import examTemp from './config-examTemp';
import trainSite from './config-trainSite'
import abilityCheckCategory from './config-abilityCheckCategory'
import abilityCheckItem from "./config-abilityCheckItem";
import workflowProcDef from "./config-workflowProcDef";
import workflowAuditMethod from "./config-workflowAuditMethod";
import classInfo from "./config-classInfo";
import classInfoAll from "./config-classInfoAll";
import trainCenter from './config-trainCenter'
import plan from './config-plan'
import audit from "./config-audit";
import categoryInfo from './config-categoryInfo'
import applyStudentRecord from './config-applyStudentRecord'
import applicationInfo from './config-applicationInfo'
import roleInfo from './config-roleInfo'
import topic from './config-topic'
import label from './config-label'
import content from './config-content'
import invitation from './config-invitation'
import trainPathComment from "./config-trainPathComment";
import apply from './config-apply'
import activity from './config-activity'
import cert from './config-cert'
import subject from './config-subject'
import organizationByUser from './config-organizationByUser'
import courseware from "./config-courseware";
import homework from './config-homework';
import classAideRemoteAuth from './config-classAideRemoteAuth';
import remoteAuth from "./config-remoteAuth";
import task from './config-task'
import live from './config-live'
import series from './config-series'
import audienceGroup from './config-audienceGroup'
import path from './config-path'
import pathStage from './config-pathStage'
import adjustPlan from './config-adjustPlan'
import voiceMsg from './config-voiceMsg'
import shortVideoLabel from './config-shortVideoLabel'
import positionName from "./config-positionName";
import resumeApply from "./config-resumeApply";
import stage from './config-stage'
import stageScoreRule from './config-stageScoreRule'
import inviteLetter from './config-inviteLetter'
import practice from './config-practice'
import pathStageReport from './config-pathStageReport'
import person from './config-person'

export {
  organization,
  organizationByNoFilter,
  position,
  positionByNoFilter,
  positionCategory,
  user,
  user2,
  offlineProgram,
  question,
  questionType,
  dealer,
  exam,
  program,
  userIdentity,
  surveyTemp,
  classStudentSign,
  survey,
  examTemp,
  trainSite,
  abilityCheckCategory,
  abilityCheckItem,
  workflowProcDef,
  workflowAuditMethod,
  classInfo,
  trainCenter,
  plan,
  audit,
  categoryInfo,
  applyStudentRecord,
  applicationInfo,
  roleInfo,
  topic,
  label,
  content,
  invitation,
  trainPathComment,
  apply,
  activity,
  cert,
  subject,
  organizationByUser,
  courseware,
  homework,
  classAideRemoteAuth,
  remoteAuth,
  task,
  live,
  series,
  audienceGroup,
  path,
  pathStage,
  adjustPlan,
  voiceMsg,
  organizationBrandNode,
  shortVideoLabel,
  classInfoAll,
  positionName,
  resumeApply,
  stage,
  stageScoreRule,
  inviteLetter,
  practice,
  pathStageReport,
  person
}
